<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <path
    d="M14.094,0,12.219,2.531V4.75H9.875V2.531L8,0,6.125,2.531V4.75H3.781V2.531L1.906,0,0,2.531V16H3.781V14.125H6.125V16h3.75V14.125h2.344V16H16V2.531ZM2.375,13.188H1.438V12.25h.938Zm0-6.562H1.438V5.688h.938Zm1.406,4.688V7.563H6.125v3.75Zm4.688,1.875H7.531V12.25h.938Zm0-6.562H7.531V5.688h.938Zm1.406,4.688V7.563h2.344v3.75Zm4.688,1.875h-.937V12.25h.938Zm0-6.625h-.937V5.625h.938Zm0,0"
    fill="#8693ad"
  />
</svg>
